import styled from 'styled-components';
export const CalendarBlockOuterWrapper = styled.div(
  props => `
    // width: 37.5rem;
    display: flex;
    // flex-direction: column;
    background-color: #fff;
    border-radius: 1.2rem;
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    // top: 8rem;
    // left: 0;
    z-index: 2;
    border-radius: 1.2rem;
  `,
);